import React from 'react'

import { FormProvider } from 'react-hook-form'

import ShowListingFeature from 'app/features/ListingFeature'

import NextSeo from '~/containers/NextSeo'

import ProductSchema from './components/ProductSchema'
import { useListingView } from './hooks/useListingView'

const ListingView: RFC = () => {
  const {
    isFallback,
    isLargeSize,
    isMobile,
    listing,
    methods,
    slug,
    metaImages,
    metaTitle,
    metaDescription
  } = useListingView()

  return (
    <>
      <NextSeo
        title={metaTitle}
        description={metaDescription}
        openGraph={{
          title: metaTitle,
          description: metaDescription,
          images: metaImages ?? []
        }}
        {...(!listing?.id && { canonical: '404' })}
      />

      {!!listing?.id && <ProductSchema listing={listing} />}

      <FormProvider {...methods}>
        <ShowListingFeature
          listing={listing}
          isMobile={isMobile}
          slug={slug}
          isLoading={isFallback}
          isLargeSize={isLargeSize}
        />
      </FormProvider>
    </>
  )
}

export default ListingView
